/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import CursoAprendizajeForm from './CursoAprendizajeForm';
import * as validations from '../../validations/validations';
import * as cursoaprendizajeActions from '../../actions/cursoaprendizajeActions';
import * as cursoActions from '../../actions/cursoActions';
 
import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";

import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
 import $ from 'jquery';

import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';
import withRouter from '../common/withRouter';

class ManageCursoAprendizajeForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			cursoaprendizaje:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        usuarioActual(this, "cursoaprendizaje",true).then( (usuario)=>{
            let id=this.props.id;
            this.props.cursoActions.getCursoCombo(usuario).then(()=>{}) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 

            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true); 
            if(id && id>0 ){
                this.props.cursoaprendizajeActions.getCursoAprendizaje(id, usuario).then( cursoaprendizaje=>{
                   this.setState({"cursoaprendizaje":cursoaprendizaje});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        
    
 
		
    }
    

    handleChange=(event, data)=> {

        let cursoaprendizaje = this.state.cursoaprendizaje;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		cursoaprendizaje[field[0]]= value;
		else{
             if(!cursoaprendizaje[field[0]]){
                    cursoaprendizaje[field[0]]={}
                }
			cursoaprendizaje[field[0]][field[1]]= value;
		}
        
		
        this.setState({"cursoaprendizaje": cursoaprendizaje});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let cursoaprendizaje=this.state.cursoaprendizaje;
              
        if(!validations.requerido(cursoaprendizaje.texto)){
            errors.texto=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(cursoaprendizaje.cursoId)){
            errors.cursoId=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.cursoaprendizajeActions.save(this.state.cursoaprendizaje, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <CursoAprendizajeForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.cursoaprendizaje}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
    return {        
            ajaxCallInProgress:state.ajaxCallInProgress,
            
            showSidebarIzquierda: state.showSidebarIzquierda,
            sidebarIzquierda: state.sidebarIzquierda, 
            color:state.color,
            user:state.user, 
            idioma:state.idioma,
            form:state.form,
            cursoCombo:state.cursoCombo,
            strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
        userActions:bindActionCreators(userActions, dispatch),
        menuActions:bindActionCreators(menuActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        cursoaprendizajeActions: bindActionCreators(cursoaprendizajeActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch)
	};
}



export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCursoAprendizajeForm));